import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

const query = gql`
  query history {
    history {
      id
      status
      isQueue
      isCancelled
      isConfirmed
      activity {
        id
        name
        infoText
        color
        location {
          id
          name
        }
      }
      occasion {
        id
        at
        duration
      }
    }
  }
`;

const History = (props) => {
  const { data, loading, error } = useQuery(query);
  console.log(data);
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;
  return <div />;
};

export default History;
